<template>
    <el-form label-position="top" ref="form" :rules="rules" :model="formFields">
        <el-form-item prop="companyName">
            <template #label>
                <span>Company Name</span>
                <el-tooltip v-if="!isSystemAdmin" class="item" effect="dark" placement="top-start" popper-class="lg:w-52">
                    <div slot="content">
                        To edit this field, please reach out to Hera Support.
                    </div>
                    <i class="uil uil-question-circle text-base"></i>
                </el-tooltip>
            </template>
            <el-input :disabled="!isSystemAdmin" data-cy="cd-company-name-in" v-model="formFields.companyName"></el-input>
            
        </el-form-item>

        <el-form-item prop="shortCode">
            <template #label>
                <span>Short Code</span>
                <el-tooltip v-if="!isSystemAdmin" class="item" effect="dark" placement="top-start" popper-class="lg:w-52">
                    <div slot="content">
                        To edit this field, please reach out to Hera Support.
                    </div>
                    <i class="uil uil-question-circle text-base"></i>
                </el-tooltip>
            </template>
            <el-input :disabled="!isSystemAdmin" data-cy="cd-short-code-in" v-model.trim="formFields.shortCode"></el-input>
            
        </el-form-item>
        <!--
        <el-form-item label="Dispatch Phone Number">
            <el-input data-cy="cd-dispatch-number-in" v-model="formFields.dispatchNumber" v-mask="'(###) ###-####'" placeholder="(123) 456-7890"></el-input>
        </el-form-item>

        <el-form-item prop="stripeBillingEmail" label="Billing Email">
            <el-input data-cy="cd-stripe-billing-email-in" v-model.trim="formFields.stripeBillingEmail" placeholder="athena@herasolutions.app"></el-input>
        </el-form-item>
        -->

        <el-form-item label="Locale" prop="locale">
            <template #label>
                <span>Locale</span>
                <el-tooltip class="item" effect="dark" placement="top-start" popper-class="lg:w-52">
                    <div slot="content">
                        Controls how dates are formatted in coaching messages.
                    </div>
                    <i class="uil uil-question-circle text-base"></i>
                </el-tooltip>
            </template>
            <el-select v-model="formFields.locale" filterable placeholder="Select Locale" data-cy="cd-locale-select">
                <el-option v-for="loc in localeOptions" :key="loc.value" :label="loc.label" :value="loc.value"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item>
            <template slot="label">
              Station Address
              <el-tooltip v-if="!isSystemAdmin" class="item" effect="dark" content="Please contact Hera Support to change your station address." :placement="isDeviceMobileOnly() ? 'bottom' : 'top-start'">
                <i class="text-gray-700 uil uil-question-circle text-base"></i>
              </el-tooltip>
            </template>
            <div class="mb-1">
                <el-input :disabled="!isSystemAdmin" data-cy="cd-address-line-1-in" v-model="formFields.addressLine1" placeholder="123 Main St"></el-input>
            </div>
            <div class="mb-1">
                <el-input :disabled="!isSystemAdmin" data-cy="cd-address-line-2-in" v-model="formFields.addressLine2" placeholder="Suite #123"></el-input>
            </div>
            <div class="mb-1 flex space-x-1">
                <el-input :disabled="!isSystemAdmin" data-cy="cd-address-city-in" v-model="formFields.addressCity" placeholder="Los Angeles"></el-input>
                <el-input :disabled="!isSystemAdmin" data-cy="cd-address-state-in" v-model="formFields.addressState" placeholder="CA"></el-input>
                <el-input :disabled="!isSystemAdmin" data-cy="cd-address-zip-in" v-model="formFields.addressZip" placeholder="90056"></el-input>
            </div>
        </el-form-item>
        <el-form-item v-if="isSystemAdmin" label="Time Zone">
            <TimeZoneSelect data-cy="cd-modal-timezone-sel" v-model="formFields.timeZone" />
        </el-form-item>
    </el-form>
</template>

<script>
import TimeZoneSelect from './TimeZoneSelect'

export default {
    
    props:['formFields', 'rules'],
    components: { TimeZoneSelect },
    data() {
        return {
            localeOptions: [
                { value: 'en-US', label: 'English (US) — MM/DD/YYYY' },
                { value: 'en-CA', label: 'English (Canada) — YYYY-MM-DD' },
                { value: 'es-MX', label: 'Spanish (Mexico) — DD/MM/YYYY' },
            ]
        }
    },
    computed: {
        isSystemAdmin() {
            return this.$store.getters.isSystemAdmin
        }
    },

}
</script>
